// import components
import { Box, IconButton, styled, SxProps, Tooltip } from '@mui/material';
import {
  GridContainerFullWidth,
  GridCompact2,
  GridCompact4,
  GridCompact6
} from '../Grid/Grid.components';
import { StyledBoxFlexWrapEnd } from '../Box/Box.styles';

// import hooks
import { useTranslation } from 'react-i18next';

// import constants
import { PRIMARY } from 'constants/colors';

// import utils
import { brightness } from 'utils/misc';
import { Icon } from '@sdb/planning-ui';

const StyledActionCard = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${PRIMARY};
  border-radius: 4px;
  background-color: ${brightness(PRIMARY, 90)};
  padding: 14px 20px;
  position: relative;
  gap: 16px;
  width: 100%;
`;

const Title = styled('h3')`
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  font-size: 16px;
  font-family: 'SourceSansPro-Bold';
`;

type Props = {
  children?: React.ReactNode;
  sx?: SxProps;
  className?: string;
  title: string;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
};

export default function ActionCard({
  children,
  sx,
  title,
  onEditClick,
  onDeleteClick
}: Props) {
  const { t } = useTranslation('common');
  return (
    <StyledActionCard sx={sx}>
      <GridContainerFullWidth>
        <GridCompact4>
          <Title>{title}</Title>
        </GridCompact4>
        <GridCompact6>{children}</GridCompact6>
        <GridCompact2
          sx={{
            ml: 'auto'
          }}
        >
          <StyledBoxFlexWrapEnd>
            {onEditClick && (
              <Tooltip title={t('edit')}>
                <IconButton onClick={onEditClick} color="primary" size="large">
                  <Icon type="pen-to-square" fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDeleteClick && (
              <Tooltip title={t('delete')}>
                <IconButton
                  onClick={onDeleteClick}
                  color="primary"
                  size="large"
                >
                  <Icon type="xmark" fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </StyledBoxFlexWrapEnd>
        </GridCompact2>
      </GridContainerFullWidth>
    </StyledActionCard>
  );
}
